
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(2(13|2|3)|[03]88|120|139|374|641|873)|2(036|110|244|280|333|446|658|92)|5(9(07|18|47)|7(14|36|76)|(14|22|56)8|853)|6(3(09|82|94)|[78]57|418)|1(2(33|64|88)|(50|58|84)2|424|696|839|923|960)|8(007|065|452|486|98)|7(017|030|187|332|340|539|681|804|896|911|936)|3(4(05|57|67)|9(36|75|94)|224|266|589|785)|9(8(08|15|61)|288|431|475|724))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
